// src/utils/widgetPatterns.ts

/**
 * Widget pattern definitions for dynamic data updates
 */
export const WIDGET_PATTERNS = {
  POPULAR_ITEMS: ['popular', 'PopularItems']
} as const;

/**
 * Check if a widget type matches any of the given patterns
 * @param widgetType - The widget type to check (e.g., 'ClassicPopularItems', 'BasicCombo')
 * @param patterns - Array of patterns to match against
 * @returns true if the widget type matches any pattern
 */
export function matchesPattern(widgetType: string, patterns: readonly string[]): boolean {
  return patterns.some(pattern => 
    widgetType.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Check if a widget is a popular items widget
 * @param widgetType - The widget type to check
 * @returns true if it's a popular items widget
 */
export function isPopularItemsWidget(widgetType: string): boolean {
  return matchesPattern(widgetType, WIDGET_PATTERNS.POPULAR_ITEMS);
}
